<template>
    <div>{{ brand }}-{{ display_card }}</div>
</template>

<script>
export default {
    props: ['display_card', 'brand']
}

</script>